/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlbumManagementEditAlbumResponse } from "./AlbumManagementEditAlbumResponse";

export type AlbumManagementEditAlbumResponseApiRespoonse = {
  data?: AlbumManagementEditAlbumResponse;
  status?: AlbumManagementEditAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AlbumManagementEditAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
